// Data Importer module (spec: docs/plans/data-importer-integration-plan.md).
// Screen 1 "Defendants" only, for now — the Defendant/Warrant Details forms
// (DefendantsDetailsForm.jsx, WarrentDetailsForm.jsx). Field values are the
// vwJdxArrWarIss view's actual API field names (not the local form field
// names, which were renamed for the UI — e.g. "lastName" locally vs
// "defLName" here) so an admin configuring Security Rules is matching
// against the real data field, same convention as warrants.js.
export const SCHEMA_NAME = "DataImporter";

export const FIELDS = {
  // Defendant section
  WARRANT_NUMBER: "warrantNum",
  JACKET_ID: "arrWarJacketId",
  WARRANT_ID: "arrWarWarrantId",
  LAST_NAME: "defLName",
  FIRST_NAME: "defFName",
  MIDDLE_NAME: "defMName",
  SSN: "defSsn",
  DOB: "defDob",
  RACE: "defRace",
  SEX: "defSex",
  HOME_PHONE: "defHomePhone",
  WORK_PHONE: "defWorkPhone",
  SID: "defSid",
  STREET_NUMBER: "defAddrNum",
  STREET: "defAddr",
  STREET_2: "defAddr2",
  APT: "defAddrApt",
  CITY: "defCity",
  STATE: "defState",
  ZIP: "defZip",
  // Warrant section
  OCA: "oca",
  ORI: "origAgencyOri",
  JUDGE_NAME: "judgeName",
  ADDRESS_BOOK_ID: "addressBookId",
  OFFENSE_CITY: "offenseCity",
  BOND_TYPE: "bondType",
  BOND_AMOUNT: "bondAmount",
};
